import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store";

const selectGlobalState = createSelector(
  (state: RootState) => state.globalState,
  (globalState) => globalState
);

export const selectGlobalCurrentTime = createSelector(
  selectGlobalState,
  (globalState) => globalState.currentGlobalTime
);
